// Paleta del tema Neon. Fósforo saturado sobre casi-negro; estética
// táctica C5i fiel al video de referencia del cliente.
//
// Ver vue/docs/desing-claude/neon/ para decisiones de diseño y trade-offs
// operativos (fatiga visual, saturación en alta densidad).

export default {
  meta: {
    id: 'neon',
    nombre: 'Neon',
    descripcion: 'Alto impacto visual, paleta neón sobre casi-negro. Prioriza estética sobre fatiga visual en turnos largos.',
    modo: 'oscuro',
  },

  paleta: {
    // Patrulla / Device — verde neón (color firma del tema)
    'patrulla-normal':         '#52FF6A',
    'patrulla-atenuado':       '#2A8A3A',

    // Cámara — teal saturado, diferenciado del verde de patrulla
    'camara-normal':           '#00E5C7',
    'camara-atenuado':         '#007A6B',

    // LPR — violeta eléctrico (libera familia verde)
    'lpr-normal':              '#B84FFF',
    'lpr-atenuado':            '#5C267F',

    // Bus — verde lima (más amarillo que patrulla para diferenciar)
    'bus-normal':              '#C6FF4A',
    'bus-atenuado':            '#638528',

    // Sensor — ámbar neón en standby, rojo saturado en alerta
    'sensor-standby':          '#FFB400',
    'sensor-alerta':           '#FF2D3A',

    // Incidente (fallback genérico; las categorías CNIE tienen su propio color)
    'incidente-activo':        '#FF2D3A',
    'incidente-baja':          '#994050',

    // Categorías CNIE v3.0 — versión neón manteniendo el hue base de
    // cada grupo para no desorientar al operador acostumbrado al otro tema
    // Familia cromática del manual oficial federal — versión neón
    // (saturación alta high-key sobre fondo oscuro, máximo contraste).
    'cat-seguridad':           '#4A9EFF',   // azul neón eléctrico
    'cat-medico':              '#3FE07A',   // verde neón vital
    'cat-proteccion-civil':    '#FFD02C',   // ámbar neón
    'cat-servicios-publicos':  '#9B5CFF',   // morado neón
    'cat-asistencia':          '#FF8A3D',   // naranja saturado
    'cat-otros-servicios':     '#8A94A3',   // gris frío (excepción intencional no-neón)
    'cat-mal-uso':             '#FF4545',   // rojo neón advertencia

    // Devices: paleta neón saturada manteniendo familias de hue para
    // que el operador familiarizado con otros temas no se desoriente.
    'device-policia-municipal-normal':    '#3D8AFF',   // azul neón
    'device-policia-municipal-atenuado':  '#1F4885',
    'device-policia-estatal-normal':      '#1A6BFF',   // azul más profundo
    'device-policia-estatal-atenuado':    '#0F3580',
    'device-policia-ministerial-normal':  '#B84FFF',   // violeta (familia LPR/mal_uso)
    'device-policia-ministerial-atenuado':'#5C267F',
    'device-gn-normal':                   '#FFD02C',   // dorado neón
    'device-gn-atenuado':                 '#7F671A',
    'device-transito-normal':             '#FF8A3D',   // naranja vialidad
    'device-transito-atenuado':           '#7F451E',
    'device-ambulancia-normal':           '#FF45A8',   // rosa-magenta médico
    'device-ambulancia-atenuado':         '#7F2354',
    'device-bomberos-normal':             '#FF2D3A',   // rojo bombero (mismo que SOS in_progress)
    'device-bomberos-atenuado':           '#7F151D',
    'device-proteccion-civil-normal':     '#FFD02C',
    'device-proteccion-civil-atenuado':   '#7F671A',
    'device-transporte-publico-normal':   '#C6FF4A',   // verde lima (familia bus)
    'device-transporte-publico-atenuado': '#638528',
    'device-funcionario-normal':          '#00E5C7',   // teal (familia cámara)
    'device-funcionario-atenuado':        '#007A6B',
    'device-dron-normal':                 '#B84FFF',   // violeta neón (familia LPR)
    'device-dron-atenuado':               '#5C267F',
    'device-otros-normal':                '#8A94A3',   // gris frío
    'device-otros-atenuado':              '#454D58',

    // SOS — rojo puro más saturado que incidente
    'sos-esperando':           '#FF0024',
    'sos-en-progreso':         '#FF2D3A',
    'sos-finalizado':          '#8A2028',

    // Neutrales
    'neutro-apagado':          '#4F5867',
    'neutro-texto-oscuro':     '#F2F4F7',
    'neutro-texto-claro':      '#050709',
  },

  overrides: {
    // Documentación de intención: los overrides del tema Neon reiteran
    // los campos de la regla base porque el sistema declarativo actual
    // no modula glow/blur por tema — el glow visual viene del tema del
    // Sistema A (glow-sos, glow-alert) aplicado vía CSS en los layers
    // MapLibre. Estos overrides sirven de documentación + anchor para
    // futuras modulaciones por tema cuando el generator soporte `glow`.
    'sos.WAITING_OPERATOR': {
      fondo: 'sos-esperando',
      halo: 'sos-esperando',
      pulseIfYoung: true,
      razon: 'Tema Neon: SOS waiting es el punto visualmente más intenso del producto',
    },
    'sensor.up': {
      fondo: 'sensor-standby',
      razon: 'Tema Neon: sensor en estado up sin glow adicional — alta densidad saturaría con halos agregados',
    },
  },
}
